import api from "./client";

// Public blog routes
export async function getPublishedPosts() {
  const { data } = await api.get("/api/blog");
  return Array.isArray(data.data) ? data.data : Array.isArray(data) ? data : [];
}

export async function getPostBySlug(slug) {
  const { data } = await api.get(`/api/blog/${slug}`);
  return data.data ?? data;
}

export async function toggleLike(slug) {
  const { data } = await api.post(`/api/blog/${slug}/like`);
  return data;
}

export async function getPublicComments(slug) {
  const { data } = await api.get(`/api/blog/${slug}/comments`);
  return Array.isArray(data.data) ? data.data : Array.isArray(data) ? data : [];
}

export async function addComment(slug, payload) {
  const { data } = await api.post(`/api/blog/${slug}/comments`, payload);
  return data;
}

// Admin blog CRUD
export async function getAdminPosts() {
  const { data } = await api.get("/api/admin/blog");
  return data.data ?? data;
}

export async function createPost(payload) {
  const { data } = await api.post("/api/admin/blog", payload);
  return data;
}

export async function updatePost(id, payload) {
  const { data } = await api.put(`/api/admin/blog/${id}`, payload);
  return data;
}

export async function deletePost(id) {
  await api.delete(`/api/admin/blog/${id}`);
}

// Comments moderation (admin)
export async function getComments() {
  const { data } = await api.get("/api/admin/comments");
  return data.data ?? data;
}

export async function approveComment(id, approve = true) {
  const { data } = await api.patch(`/api/admin/comments/${id}/approve`, { is_approved: approve });
  return data;
}

export async function deleteComment(id) {
  await api.delete(`/api/admin/comments/${id}`);
}

// Upload image
export async function uploadImage(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/api/upload", form);
  return data.url;
}
